import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import MuiIconButton from "@mui/material/IconButton";
import type { IconButtonProps as MuiIconButtonProps } from "@mui/material/IconButton";
import type { BaseAtomProps, ComponentSize } from "@/components/types";

export interface CloseButtonProps
  extends Omit<MuiIconButtonProps, "children" | "size">,
    BaseAtomProps {
  /**
   * Click handler for close action
   */
  onClick?: () => void;

  /**
   * Button size with mobile-first considerations
   */
  size?: ComponentSize;

  /**
   * Disabled state
   */
  disabled?: boolean;

  /**
   * Icon color
   */
  iconColor?:
    | "inherit"
    | "primary"
    | "secondary"
    | "error"
    | "warning"
    | "info"
    | "success";
}

const CloseButtonComponent: React.FC<CloseButtonProps> = ({
  onClick,
  size = "medium",
  disabled = false,
  iconColor: _iconColor = "primary",
  className,
  ...props
}) => {
  return (
    <MuiIconButton
      onClick={onClick}
      size={size}
      disabled={disabled}
      className={className}
      sx={{
        position: "absolute",
        top: { xs: 16, x2l: 10 },
        right: { xs: 16, x2l: 10 },
        width: "42px",
        height: "42px",
        zIndex: 1000,
        backgroundColor: "background.default",
        transition: "background-color 0.2s ease",
        "&:hover": {
          backgroundColor: "background.default",
        },
      }}
      {...props}
    >
      <CloseIcon
        fontSize="small"
        sx={(theme) => ({
          color: theme.palette.mode === "dark" ? "white" : "black",
        })}
      />
    </MuiIconButton>
  );
};

// Apply memoization with performance monitoring
export const CloseButton = CloseButtonComponent;

// Set display name for debugging
(CloseButton as any).displayName = "CloseButton";
